var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPersonalDetails = function SvgPersonalDetails(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "96px",
    viewBox: "0 0 147 96",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Personal details")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Personal-details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(1.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.6193,92.4502 L6.0003,92.4502 C2.6863,92.4502 0.0003,89.7642 0.0003,86.4502 L0.0003,6.0002 C0.0003,2.6862 2.6863,0.0002 6.0003,0.0002 L139.6193,0.0002 C142.9333,0.0002 145.6193,2.6862 145.6193,6.0002 L145.6193,86.4502 C145.6193,89.7642 142.9333,92.4502 139.6193,92.4502 Z",
    id: "Stroke-1",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(19.000000, 38.450500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4426,13.6716 C0.4426,6.5986 6.1766,0.8636 13.2516,0.8636 C20.3246,0.8636 26.0586,6.5986 26.0586,13.6716",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.4426,13.6716 C0.4426,6.5986 6.1766,0.8636 13.2516,0.8636 C20.3246,0.8636 26.0586,6.5986 26.0586,13.6716",
    id: "Stroke-5",
    stroke: "#00C5E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.6906,30.874 C40.6906,35.535 36.9126,39.314 32.2516,39.314 C27.5896,39.314 23.8106,35.535 23.8106,30.874 C23.8106,26.213 27.5896,22.435 32.2516,22.435 C36.9126,22.435 40.6906,26.213 40.6906,30.874",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6906,30.874 C40.6906,35.535 36.9126,39.314 32.2516,39.314 C27.5896,39.314 23.8106,35.535 23.8106,30.874 C23.8106,26.213 27.5896,22.435 32.2516,22.435 C36.9126,22.435 40.6906,26.213 40.6906,30.874 Z",
    id: "Stroke-9",
    stroke: "#00C5E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2111,52.1221 L15.2911,52.1221 C13.6341,52.1221 12.2911,50.7791 12.2911,49.1221 L12.2911,15.2021 C12.2911,13.5461 13.6341,12.2021 15.2911,12.2021 L49.2111,12.2021 C50.8671,12.2021 52.2111,13.5461 52.2111,15.2021 L52.2111,49.1221 C52.2111,50.7791 50.8671,52.1221 49.2111,52.1221 Z",
    id: "Stroke-11",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.7355,
    y1: 30.6026,
    x2: 101.9475,
    y2: 30.6026,
    id: "Stroke-13",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.7355,
    y1: 41.0186,
    x2: 125.7665,
    y2: 41.0186,
    id: "Stroke-15",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.7355,
    y1: 52.1221,
    x2: 125.7665,
    y2: 52.1221,
    id: "Stroke-17",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.7355,
    y1: 76.4199,
    x2: 125.7665,
    y2: 76.4199,
    id: "Stroke-19",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.7355,
    y1: 66.7901,
    x2: 125.7665,
    y2: 66.7901,
    id: "Stroke-21",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2111,66.7901 L15.9191,66.7901 C14.8151,66.7901 13.9191,67.6861 13.9191,68.7901 L13.9191,74.4201 C13.9191,75.5241 14.8151,76.4201 15.9191,76.4201 L50.2111,76.4201 C51.3151,76.4201 52.2111,75.5241 52.2111,74.4201 L52.2111,68.7901 C52.2111,67.6861 51.3151,66.7901 50.2111,66.7901 Z",
    id: "Stroke-23",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonalDetails, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/personalDetails.a15d6dab.svg";
export { ForwardRef as ReactComponent };